import { observable } from 'mobx';
import type { LegTerminalResponseArgs } from './leg_terminal';
import LegTerminal, { convertLegTerminalResponseToArgs } from './leg_terminal';

export type LegResponseArgs = {
  name: string;
  from: LegTerminalResponseArgs;
  to: LegTerminalResponseArgs;
  type?: string;
  airline_name?: string;
};

export type LegArgs = {
  name: string;
  from: LegTerminal;
  to: LegTerminal;
  type?: string;
  airlineName?: string;
};

export const convertLegResponseToArgs = (response: LegResponseArgs) => {
  const args: LegArgs = {
    name: response.name,
    from: new LegTerminal(convertLegTerminalResponseToArgs(response.from)),
    to: new LegTerminal(convertLegTerminalResponseToArgs(response.to)),
    type: response.type,
    airlineName: response.airline_name
  };
  return args;
};

export default class Leg {
  @observable name: string;
  @observable from: LegTerminal;
  @observable to: LegTerminal;
  @observable type?: string;
  @observable airlineName?: string;

  constructor(args: LegArgs) {
    this.name = args.name;
    this.from = args.from;
    this.to = args.to;
    this.type = args.type;
    this.airlineName = args.airlineName;
  }
}
